module.exports = __webpack_public_path__ + "img/project_15.cc5531e1.png";